module.exports = __webpack_public_path__ + "static/steelhead-ca4bddcec28db5f9d0c27deeaaaefc8a.png";